import * as React from 'react';
import { observer } from 'mobx-react';
import { AdvanceTable, DangerAlert, IBasicTableProps, Typography } from 'ui-lib';
import { AbstractDeviceDetailWithCommandCodeStore } from 'store/device-details/device-detail-with-command-code-store';
import devicesCss from './devices.css';

export interface IDeviceReportTableProps {
    store: AbstractDeviceDetailWithCommandCodeStore<unknown>;
    table: IBasicTableProps;
}

export const DeviceReportTable = observer(({ store, table }: IDeviceReportTableProps) => (
    <div className={devicesCss.tabPane}>
        {store.error != undefined && <DangerAlert closable={false} message='Error' description={store.error} />}
        <AdvanceTable
            title=''
            table={table}
            loadingState={store.loading}
            toolbar={{
                extraItems: [
                    <Typography.Text key='refreshStatus' italic={true}>
                        {store.refreshing ? 'Refreshing...' : 'Refresh to get latest status'}
                    </Typography.Text>,
                ],
                onReload: (): Promise<void> => store.fetchLatestData(),
            }}
        />
    </div>
));
